import React, { useEffect, useState } from "react";
import {
  Formik,
  Form,
  Field,
  FieldArray,
  ErrorMessage,
  FormikProvider,
} from "formik";

import { Text } from "@chakra-ui/react";
import FirstName from "./FirstName";
import LastName from "./LastName";
import Email from "./Email";
import Phone from "./Phone";
import Address from "./Address";
import TextField from "./TextField";
import Url from "./Url";
import Rating from "./Rating";
import Paragraph from "./Paragraph";
import Numbers from "./Number";
import DropDown from "./DropDown";
import CheckBox from "./CheckBox";
import SubmitButton from "./SubmitButton";

const FIELD_TYPES = {
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  phone: "phone",
  address: "address",
  textField: "textField",
  url: "url",
  paragraph: "paragraph",
  number: "number",
  dropDown: "dropDown",
  checkBox: "checkBox",
  rating: "rating",
  submitBtn: "submitBtn",
};

const FormFields = ({ fields, submitConfig, formik, standardFields }) => {
  const setValues = formik.setValues;
  const renderField = (field) => {
    switch (field.type) {
      case FIELD_TYPES.firstName: {
        return <FirstName key={field.uid} formik={formik} options={field} />;
      }
      case FIELD_TYPES.lastName: {
        return <LastName key={field.uid} formik={formik} options={field} />;
      }
      case FIELD_TYPES.email: {
        return <Email key={field.uid} formik={formik} options={field} />;
      }
      case FIELD_TYPES.phone: {
        return <Phone key={field.uid} formik={formik} options={field} />;
      }
      case FIELD_TYPES.address: {
        return <Address key={field.uid} formik={formik} options={field} />;
      }
      case FIELD_TYPES.submitBtn: {
        return <SubmitButton key={field.uid} options={field} />;
      }
      case FIELD_TYPES.textField: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="textField"
                render={() =>
                  standardFields.textField.map((field, i) => {
                    return (
                      <TextField
                        key={`textField-${i}`}
                        formik={formik}
                        id={i}
                        options={standardFields.textField[i]}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
      case FIELD_TYPES.url: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="url"
                render={() =>
                  standardFields.url.map((field, i) => {
                    return (
                      <Url
                        key={`url-${i}`}
                        formik={formik}
                        id={i}
                        options={standardFields.url[i]}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
      case FIELD_TYPES.rating: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="rating"
                render={() =>
                  standardFields.rating.map((field, i) => {
                    return (
                      <Rating
                        key={`rating-${i}`}
                        formik={formik}
                        id={i}
                        options={standardFields.rating[i]}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
      case FIELD_TYPES.paragraph: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="paragraph"
                render={() =>
                  standardFields.paragraph.map((field, i) => {
                    return (
                      <Paragraph
                        key={`paragraph-${i}`}
                        formik={formik}
                        id={i}
                        options={standardFields.paragraph[i]}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
      case FIELD_TYPES.number: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="number"
                render={() =>
                  standardFields.number.map((field, i) => {
                    return (
                      <Numbers
                        key={`number-${i}`}
                        formik={formik}
                        id={i}
                        options={standardFields.number[i]}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
      case FIELD_TYPES.dropDown: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="dropDown"
                render={() =>
                  standardFields.dropDown.map((field, i) => {
                    return (
                      <DropDown
                        key={`dropDown-${i}`}
                        formik={formik}
                        id={i}
                        options={standardFields.dropDown[i]}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
      case FIELD_TYPES.checkBox: {
        return (
          <div key={field.type}>
            <FormikProvider value={formik}>
              <FieldArray
                name="checkBox"
                render={() =>
                  standardFields.checkBox.map((field, i) => {
                    return (
                      <CheckBox
                        key={`checkBox-${i}`}
                        formik={formik}
                        id={i}
                        options={field}
                      />
                    );
                  })
                }
              />
            </FormikProvider>
          </div>
        );
      }
    }
  };
  useEffect(() => {
    const allSelectedCheckboxes = [];
    standardFields.checkBox.map((field, i) => {
      const selectedCheckboxes = { [field.label]: [] };
      field.choices.map((element, index) => {
        element.checked && selectedCheckboxes[field.label].push(element.name);
      });
      allSelectedCheckboxes.push(selectedCheckboxes);
    });
    setValues({ ...formik.values, checkBox: allSelectedCheckboxes });
  }, []);
  const renderFields = () => {
    if (!fields.length) {
      return <Text>No fields</Text>;
    }
    const CONTACT_FIELDS = [
      "firstName",
      "lastName",
      "phone",
      "email",
      "address",
    ];

    const contactFields = [];

    fields.map((field) => {
      if (CONTACT_FIELDS.indexOf(field.type) != -1) {
        contactFields.push(field);
      }
    });
    const mapContactFields = contactFields.map((field) => {
      return renderField(field);
    });
    const mapStandardFields = Object.keys(standardFields).map((key) => {
      if (
        standardFields[key] != "undefined" &&
        standardFields[key] &&
        standardFields[key].length
      ) {
        return renderField({ type: key });
      }
    });
    const mapFields = [...mapContactFields, ...mapStandardFields];
    const submitButton = renderField(submitConfig);
    mapFields.push(submitButton);
    return mapFields;
  };
  return <>{renderFields()}</>;
};

export default FormFields;
